export default class userRequestResponse {
    title!: string;
    message!: string;
    responseCode!:number;
  }